export default __webpack_public_path__ + "41bbb0765fd9360beba4c7a04557f81b.png";